module.exports = __webpack_public_path__ + "39520e6a384a8fec5fc5a09442b4337a.MP3";